import {req, reqJson} from './axiosFun';

/**
 * 学校信息管理
 **/
//查询学校集合
export const schoolList = (params) => {
  return reqJson("get", "/api/school/list")
};



// WEBPACK FOOTER //
// ./src/api/schoolMG.js